import { useTranslation } from 'next-i18next';
import React, { } from 'react';
import TopNavigation from '@/components/elements/TopNavigation';
import { ModeCompraBeseif } from '@/objects/Beseif';
import { OpcionTopNavigation } from '@/objects/Menus';
import BeseifSeguimientoArticulos from './BeseifSeguimientoArticulos';

function BeseifSeguimiento() {

    const { t } = useTranslation();

    const [seccionCompras, setSeccionCompras] = React.useState<ModeCompraBeseif>(ModeCompraBeseif.COMPRAS);

    const opcionesBarraMenuMensajes: OpcionTopNavigation[] = [
        { nombre: t("menu:secciones.mis_compras.menu_modo.compras"), tipoOpcion: ModeCompraBeseif.COMPRAS },
        { nombre: t("menu:secciones.mis_compras.menu_modo.ventas"), tipoOpcion: ModeCompraBeseif.VENTAS }
    ];
    
    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', minHeight: 0, margin: 0, padding: 0, overflow: 'hidden' }}>
            <TopNavigation
                opciones={opcionesBarraMenuMensajes}
                opcionActual={seccionCompras.toString()}
                setOpcionActual={(opcion: string) => setSeccionCompras(opcion as ModeCompraBeseif)}
                style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 5,
                    flexShrink: 0,
                }}
            />

            <BeseifSeguimientoArticulos modoComprasBeseif={seccionCompras} />

        </section>
    );
}

export default BeseifSeguimiento;